const customerPrefix = "customer"

// ***** REVIEW RELATED ROUTES  *****
export const customerRoutes = {
  addContact: customerPrefix + "/add-contact",
}